module.exports = __webpack_public_path__ + "img/clickhouse.38f67e6b.svg";